export const BASICO_TEXT = 'O plano Básico tem hotéis confortáveis para sua viagem com café da manhã grátis.';
export const COMPLETO_TEXT = 'O plano Completo tem hotéis confortáveis para sua viagem com café da manhã grátis.';
export const IDEAL_TEXT = `
    Esse plano possui hotéis dos planos Completo e Ideal. As hospedagens podem ter café da manhã, meia pensão e até pensão completa!
`;
export const EXCLUSIVO_TEXT = `
    Com o plano Exclusivo você conta com hotéis das categorias Completo, Ideal e Exclusivo. Nesta seleção,
    você encontra mais hospedagens com café, meia pensão e pensão completa.
`;
export const REQUINTE_TEXT = `
    Aqui você pode reservar em qualquer hotel das categorias Completo, Ideal, Exclusivo e Requinte.
    Hotéis que vão desde café da manhã até all inclusive para escolher.
`;
export const PLUS_TEXT = `
    Hospedagens inesquecíveis esperam por você! Hotéis das categorias Completo, Ideal, Exclusivo,
    Requinte e Plus para escolher, sendo vários com all inclusive.
`;
export const BLACK_TEXT = `
    Os melhores hotéis do país com muito luxo te aguardam. Hotéis dos planos Completo, Ideal, Exclusivo, Requinte, Plus
    e Black estão aqui. All Inclusive e hospedagens espetaculares para você.
`;

export const BASICO_TEXT_1           = 'Essa modalidade é ideal para você que tem o destino como principal' +
    ' foco na sua viagem e procura boas hospedagens, com acomodações confortáveis para seu próximo descanso.';

export const BASICO_TEXT_2           = 'O plano Básico tem hotéis confortáveis para sua viagem ' +
    '<strong>com café da manhã grátis</strong> ' +
    'e são comercializados com ' +
    '<strong>parcelas de 7 diárias por R$ 000,00 sem juros</strong> ' +
    'no plano para' +
    '<strong> duas pessoas.</strong>';

export const COMPLETO_TEXT_1         = 'Para quem busca uma <strong>viagem</strong> inesquecível, aproveitando ainda mais o destino,' +
    ' este plano é ideal para você. Conte com uma ' +
    '<strong>lista variada de hotéis</strong>' +
    ' com acomodações aconchegantes e aproveite cada momento.';

export const COMPLETO_TEXT_2         = 'A modalidade contempla todos hotéis do plano Básico + vários especiais com café' +
    ' da manhã e são comercializados com parcelas ' +
    '<strong>de 7 diárias por R$ 000,00</strong>' +
    ' sem juros no plano para' +
    ' <strong>duas pessoas.</strong> ';

export const IDEAL_TEXT_1            = 'Aqui você conta com uma lista maior de hotéis, com opções incríveis' +
    ' para aproveitar sua estadia e o destino com tranquilidade para viver experiências ainda mais inesquecíveis para sua viagem.';

export const IDEAL_TEXT_2            = 'O plano Ideal contempla todos hotéis dos planos Básico e Completo + hotéis' +
    ' incríveis todos com café da manhã sendo ' +
    '<strong>16 com meia pensão</strong>' +
    ' e são comercializados com parcelas ' +
    '<strong>de 7 diárias por R$ 000,00</strong> ' +
    ' sem juros no plano para ' +
    ' <strong> duas pessoas.</strong>';

export const EXCLUSIVO_TEXT_1        = 'Se o Hotel é seu destino, essa modalidade é ideal para você.' +
    ' Aqui você aproveita a experiência de uma hospedagem completa, com hotéis de categoria superior,' +
    ' para se divertir e ficar sossegado sem preocupação.';

export const EXCLUSIVO_TEXT_2        = 'O plano Exclusivo contempla todos hotéis dos planos Básico,' +
    ' Completo e Ideal + hotéis exclusivos* todos com café da manhã sendo ' +
    '<strong>18 com pensão completa</strong> e são' +
    ' comercializados com parcelas ' +
    '<strong>de 7 diárias por R$ 000,00</strong> sem juros no plano para ' +
    '<strong>duas pessoas.</strong>';

export const REQUINTE_TEXT_1         = 'Viva experiências incríveis em sua próxima viagem com hotéis que vão' +
    ' surpreender você. Seu descanso será muito bem aproveitado em vários destinos com conforto e sofisticação.';

export const REQUINTE_TEXT_2         = 'A modalidade contempla todos hotéis dos planos Básico, Completo,' +
    ' Ideal e Exclusivo + hotéis sofisticados todos com café da manhã sendo <strong>24</strong>' +
    ' all inclusive e são comercializados com parcelas ' +
    ' <strong>de 7 diárias por R$ 000,00</strong>' +
    ' sem juros no plano para ' +
    ' <strong>duas pessoas.</strong>';

export const PLUS_TEXT_1             = 'Desfrute de hotéis inesquecíveis, com alto padrão na hotelaria' +
    ' em destinos paradisíacos. Tudo que você merece para sair da rotina,' +
    ' ter novas experiências e aproveitar um merecido descanso.';

export const PLUS_TEXT_2             = 'A modalidade contempla todos hotéis dos planos Básico, Completo, Ideal,' +
    ' Exclusivo e Requinte + hotéis premium* todos com café da manhã ' +
    '<strong>sendo 25</strong> all inclusive e são comercializados com parcelas ' +
    '<strong>de 7 diárias por R$ 000,00</strong> sem juros no plano para ' +
    '<strong>duas pessoas.</strong>';

export const BLACK_TEXT_1            = 'Para uma viagem com <strong>experiências incríveis</strong>,' +
    ' os melhores hotéis do país e um toque de ' +
    ' <strong>luxo,</strong> essa modalidade é para você. Aproveite apartamentos da categoria superior,' +
    ' nos destinos mais incríveis.';

export const BLACK_TEXT_2            = 'A modalidade contempla todos hotéis dos demais planos' +
    ' Montreal Facilita + hotéis luxuosos* todos com café da manhã <strong>sendo 27</strong> all inclusive e são' +
    ' comercializados com parcelas ' +
    ' <strong>de 7 diárias por R$ 000,00</strong> sem juros no plano para ' +
    ' <strong>duas pessoas.</strong>';
